import Helper from './Helper';
class YoutubeLinks {
  constructor(config = {}) {
    const {
      videoContainerSelector
    } = config;
    this.videoContainer = document.querySelectorAll(videoContainerSelector);
    this.videoContainerArray = Array.prototype.slice.call(this.videoContainer);
    if (this.videoContainer) {
      this.videoContainerArray.forEach(container => {
        this.addLink(container);
      });
    }
  }
  addLink(videoContainer) {
    const videoThumbnail = videoContainer.querySelector('.lc-video__thumbnail');
    const videoCode = videoContainer.querySelector('.lc-video__video a');
    const videoSource = videoCode.href;
    const aTag = document.createElement('a');
    aTag.classList.add('lc-video__link');
    aTag.setAttribute('href', videoSource);
    aTag.setAttribute('target', '_blank');
    Helper.wrap(videoThumbnail, aTag);
  }
}
export default YoutubeLinks;
